import { createSelector } from '@reduxjs/toolkit';
export const categoryFacetSearchStateSelector = createSelector((state, facetId) => ({
    facetSearchSelector: state.categoryFacetSearchSet[facetId],
}), ({ facetSearchSelector }) => {
    return facetSearchSelector;
});
